export function getFlagEmoji(countryCode) {

    if(countryCode.toLowerCase() === 'en') {
        return '🇬🇧';
    }

    if(countryCode.toLowerCase() === 'zh') {
        return '🇨🇳';
    }

    const codePoints = countryCode
        .toUpperCase()
        .split('')
        .map(char =>  127397 + char.charCodeAt());
    return String.fromCodePoint(...codePoints);
}
